import { render, staticRenderFns } from "./FinancialIndicatorsOld.vue?vue&type=template&id=a8084ca4&"
import script from "./FinancialIndicatorsOld.vue?vue&type=script&lang=js&"
export * from "./FinancialIndicatorsOld.vue?vue&type=script&lang=js&"
import style0 from "./FinancialIndicatorsOld.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports